import { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withRepeat, withTiming } from 'react-native-reanimated';
import { brand, neutrals } from 'src/theme/colors';

export const PulseDot = () => {
  const sizeInnerPulseSV = useSharedValue(0);
  const sizeOuterPulseSV = useSharedValue(0);
  const opacitySV = useSharedValue(1);

  useEffect(() => {
    sizeOuterPulseSV.value = withRepeat(withTiming(100, { duration: 1000 }), 999, false);
    sizeInnerPulseSV.value = withRepeat(withTiming(70, { duration: 1000 }), 999, false);
    opacitySV.value = withRepeat(withTiming(0, { duration: 1000 }), 999, false);
  }, []);

  const animatedInnerStyle = useAnimatedStyle(() => {
    return { width: sizeInnerPulseSV.value, height: sizeInnerPulseSV.value, opacity: opacitySV.value };
  });
  const animatedOuterStyle = useAnimatedStyle(() => {
    return { width: sizeOuterPulseSV.value, height: sizeOuterPulseSV.value, opacity: opacitySV.value };
  });
  return (
    <View style={style.wrapper}>
      <Animated.View style={[style.innerPulse, animatedInnerStyle]} />
      <Animated.View style={[style.outerPulse, animatedOuterStyle]} />
      <View style={style.dot} />
    </View>
  );
};

const style = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    width: 100,
    height: 100,
    top: '50%',
    left: '50%',
    transform: [{ translateX: '-50%' }, { translateY: '-50%' }],
  },
  dot: {
    transform: [{ translateX: '-50%' }, { translateY: '-50%' }],
    width: 19,
    height: 19,
    backgroundColor: brand.main.water,
    borderWidth: 3,
    borderColor: neutrals.white,
    borderRadius: 19,
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: 3,
  },
  innerPulse: {
    transform: [{ translateX: '-50%' }, { translateY: '-50%' }],
    backgroundColor: neutrals.white,
    opacity: 0.57,
    borderRadius: 100,
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: 2,
  },
  outerPulse: {
    transform: [{ translateX: '-50%' }, { translateY: '-50%' }],
    backgroundColor: neutrals.white,
    opacity: 0.38,
    borderRadius: 100,
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: 1,
  },
});
